import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";

import { NotificationsService } from 'angular2-notifications';
import { CurrencyPipe } from "@angular/common";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize, switchMap } from 'rxjs/operators';

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { style } from "@angular/animations";
import { enc } from "crypto-js";
import { countReset, error } from "console";
import * as JSZip from 'jszip';
import { result } from "lodash";

@Component({
  selector: "app-alumno-operacion-formulario",
  templateUrl: "./operacion.component.html",
  styles: ["ngui-auto-complete {z-index: 999999 !important}"]
})
export class OperacionComponent implements OnInit {
  tab = 1;
  tab2 = 1;
  dato = [];
  docentes = [];
  carrera_modulo_nivel;
  periodos_escolares_niveles;
  grupos_niveles;
  carrera_plan;
  observaciones;
  invalidar_inicializacion;
  cargando = false;
  buscando = false;

  borrarCargando = false;

  // Mensaje
  titulo; mensaje; clase;

  API_PATH = environment.API_PATH;
  time_cal;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");


  public alumnos_term: string = `${environment.API_URL
    }/alumnos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal
    }`;

  tieneid: boolean = false;

  auto = 0;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));
  permisos = JSON.parse(localStorage.getItem("permisos"));


  json;
  // datos_personales:{
  //   nombre:""
  // }
  alumnos: any = {
    id: "",
    matricula: "",
    baja: 0,
    curp: "",
    alumnos_inicializacion: {
      inicializado: 0
    },
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    email: "",
    alumnos_metadatos: {
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      matricula: "",
      email: ""
    },
    grupos: {
      nombre: "",
      clave: "",
      identificador: "",
      nivel: "",
      turnos: {
        nombre: ""
      }
    },
    becas: {
      becas: {},
      importe: 0
    },
    carrera_plan: {
      id: "",
      nombre: ""
    },
    carreras: {
      sigla: '',
      nombre: '',
      nivel_educativo: '',
      logo: ''
    },
    modalidades: {
      nombre: ""
    }
  };

  periodos_escolares;
  documentos = [];
  kardex = [];
  //grupos = [];
  estatus_alumno = [];
  finanza = {
    data: [],
    otros_pagos: [],
    cupones: []
  };
  conducta = [];
  carreras_planes;

  mensualidades = [];
  cargarDatosCatalogo = false;
  form_personas_rfcs;
  form_inscripciones_grupos_siguientes;
  form_personas_cupones;
  form_personas_incidencias;

  lista_cupones = [];
  lista_inscripciones_grupos_siguientes = [];
  lista_incidencias = [];
  personas_historial_bajas = [];
  datos_personales = {
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    curp: '',
    fecha_nacimiento: '',
    sexo: 'M',
    telefono: '',
    telefono2: '',
    email: '',
    tiene_whatsapp: 0,
    tiene_whatsapp2: 0,
    reset_contrasenia: 0
  };

  datos_adicionales = {
    domicilio_estado: '',
    domicilio_municipio: '',
    domicilio_colonia: '',
    domicilio_calle: '',
    domicilio_exterior: '',
    domicilio_interior: '',
    domicilio_referencias: '',
    tipo_sangre: '',
    factor_rh: '',
    alergias: '',
    presenta_alergias: '2',
    contacto_medico: '',
    telefono_medico: '',
    telefono_medico2: '',
    padecimientos: '',
    observaciones: ''
  };

  datos_tutores = {
    nombre: '',
    parentesco: '',
    telefono: '',
    email: '',
    nombre2: '',
    parentesco2: '',
    telefono2: '',
    email2: '',
    observaciones: ''
  };

  borrarItem;
  borrarRuta;
  data: FormGroup;
  datos_personalesF: FormGroup;

  parametros = {
    pagina: 0,
    limite: 0
  };

  busqueda = '';
  estados_civiles =
    [
      { id: 1, descripcion: "Soltero(a)" },
      { id: 2, descripcion: "Casado(a)" },
      { id: 3, descripcion: "Viudo(a)" },
      { id: 4, descripcion: "Divorciado(a)" },
      { id: 5, descripcion: "Unión libre" },
      { id: 6, descripcion: "Comprometido(a)" }
    ];

  idiomas =
    [
      { id: 1, descripcion: 'Español' },
      { id: 2, descripcion: 'Otro' },
    ];

  necesidades_especiales =
    [
      { id: 1, descripcion: 'No aplica' },
      { id: 2, descripcion: 'Con discapacidad' },
      { id: 3, descripcion: 'Con aptitudes sobresalientes' },
    ];

  tipos_de_sangre =
    [
      { id: 1, descripcion: 'A' },
      { id: 2, descripcion: 'B' },
      { id: 3, descripcion: 'AB' },
      { id: 4, descripcion: 'O' }
    ];

  factor_rh =
    [
      { id: 1, descripcion: '+' },
      { id: 2, descripcion: '-' },
    ];

  parentescos =
    [
      { id: 1, descripcion: 'Padre' },
      { id: 2, descripcion: 'Madre' },
      { id: 3, descripcion: 'Otro' },
    ];

  tipos_promocion =
    [
      { id: 1, descripcion: 'Radio' },
      { id: 2, descripcion: 'Tv' },
      { id: 3, descripcion: 'Anuncios y espectaculares' },
      { id: 4, descripcion: 'Periodicos y revistas' },
      { id: 5, descripcion: 'Redes sociales' },
      { id: 6, descripcion: 'Familia y amigos' },
      { id: 7, descripcion: 'Otros' }
    ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private crud: CrudService,
    private notificacion: NotificationsService,
    private _sanitizer: DomSanitizer,
    private http: HttpClient) { }

  ngOnInit(): void {

    this.obtenerDocumentos("BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase());
    this.obtenerDocumentos("HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase());
    this.datos_personalesF = this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      apellido_paterno: ['', [Validators.required]],
      apellido_materno: ['', [Validators.required]],
      curp: ['',],
      fecha_nacimiento: [''],
      sexo: ['M'],
      telefono: [''],
      telefono2: [''],
      email: ['', [Validators.required]],
      tiene_whatsapp2: [0],
      tiene_whatsapp: [0],
      reset_contrasenia: [0],
      datos_adicionales: this.fb.group({
        domicilio_estado: [''],
        domicilio_municipio: [''],
        domicilio_colonia: [''],
        domicilio_calle: [''],
        domicilio_exterior: [''],
        domicilio_interior: [''],
        domicilio_referencias: [''],
        tipo_sangre: [''],
        factor_rh: [''],
        alergias: [''],
        presenta_alergias: ['2'],
        contacto_medico: [''],
        telefono_medico: [''],
        telefono_medico2: [''],
        padecimientos: [''],
        observaciones: ['']
      }),
      datos_tutores: this.fb.group({
        personas_id: [''],
        nombre: [''],
        parentesco: [''],
        telefono: [''],
        email: [''],
        nombre2: [''],
        parentesco2: [''],
        telefono2: [''],
        email2: [''],
        observaciones: ['']
      }),

    });
    this.data = this.fb.group({
      id: [''],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [1],
        completado: [0],
        ultimo_abono: ['']
      }),

      personas_historial_bajas: this.fb.group({
        personas_id: [this.alumnos.id],
        inscripciones_id: ['', [Validators.required]],
        fecha_baja: ['', [Validators.required]],
        tipos_bajas_id: ['', [Validators.required]],
        observaciones: [0],
        invalidar_periodo: [0]
      }),
      personas_rfcs: this.fb.array([]),
      personas_cupones: this.fb.array([]),
      inscripciones_grupos_siguientes: this.fb.array([]),
      personas_incidencias: this.fb.array([])
    });

    this.form_personas_rfcs = {
      tipo_persona: ['Fisica', [Validators.required]],
      tipos_regimenes_fiscales_id: [],
      rfc: ['', [Validators.required]],
      razon_social: ['', [Validators.required]],
      paises_id: [1],
      estados_id: [7],
      municipios_id: [180],
      localidad: [''],
      colonia: [''],
      calle: [''],
      numero_exterior: [''],
      numero_interior: [''],
      codigo_postal: [''],
      email: [''],
      predeterminado: [0]
    };

    this.form_inscripciones_grupos_siguientes = {
      periodos_escolares_id: ['', [Validators.required]],
      grupos_id: ['', [Validators.required]],
      personas_id: [this.data.controls.id.value]
    };


    this.form_personas_cupones = {
      articulos_id: ['', [Validators.required]],
      importe: [''],
      codigo: [''],
      inicio_vigencia: [''],
      fin_vigencia: [''],
      utilizado: [0],
    };

    this.form_personas_incidencias = {
      catalogo_incidencias_id: ['', [Validators.required]],
      descripcion: [''],
      imagen_evidencia: ['']
    };
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();

    this.dato[0] = 0;
  }

  observableSource = (keyword: any): Observable<any[]> => {

    let url: string = `${environment.API_URL}/alumnos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));

    } else {
      return Observable.bind([]);
    }
  }


  listarKardex(id: any): Observable<any> {
    let url = `${this.API_PATH}/get-kardex-alumno/${id}`
    return this.http.get(url);
  }
  listarFinanciero(id: any): Observable<any> {
    let url = `${this.API_PATH}/get-historial-financiero-alumno/${id}`
    return this.http.get(url);
  }


  datosKardex = [];
  informacion = {
    nombre: '',
    curp: '',
    matricula: '',
    email: '',
    carrera: '',
    plan_estudio: '',
    modalidad: '',
    modalidad_etiqueta: '',
    total_creditos: 0,
    creditos_aprobados: 0,
    promedio_general: 0,
    numero_parciales: 0,
    tipo_periodo_etiqueta:''

  };

  datosFinancieros = [];


  verKardex() {
    this.cargando = true;
    let id = this.alumnos.id;
    this.listarKardex(id)
      .subscribe((resultado) => {
        if (resultado.status == 200) {
          this.informacion = resultado.informacion;
          this.datosKardex = resultado.data;
          this.cargando = false;
        }
      },
        error => {
          this.cargando = false;
          this.titulo = "Error";
          this.mensaje = "Documentos";
          this.clase = "danger";
          document.getElementById("message").click();
        });
  }


  verFinanciero() {
    this.cargando = true;
    let id = this.alumnos.id;
    this.listarFinanciero(id)
      .subscribe((resultado: any) => {
        //console.log(resultado);
        if (resultado.status == 200) {
          this.cargando = false;
          this.datosFinancieros = resultado.data;

          // console.log(this.datosFinancieros);

        }

      },
        error => {
          console.log(error);

        })
  }

  imprimirKardexdos() {
    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();

    doc.setFontSize(8);
    let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "") {
      doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
    }

    doc.setFont('helvetica', 'bold');

    doc.text(this.configuracion.empresa.nombre, width / 2, 12, { align: "center" });
    doc.text(this.configuracion.empresa.subnombre + ' / ' + this.configuracion.sucursal.nombre.toUpperCase(), width / 2, 17, { align: "center" });
    doc.text('KARDEX', width / 2, 22, { align: "center" });

    var columna = [
      { title: 'MATRICULA', dataKey: 'matricula' },
      { title: 'NOMBRE', dataKey: 'nombre' },
      { title: 'CURP', dataKey: 'curp' },
    ];
    var row = [
      {
        'matricula': this.informacion.matricula,
        'nombre': this.informacion.nombre,
        'curp': this.informacion.curp
      }
    ];

    var columna1 = [
      { title: 'PLAN DE ESTUDIOS', dataKey: 'plan' },
      { title: 'CARRERA', dataKey: 'carrera' },
      { title: 'MODALIDAD', dataKey: 'modalidad' },

    ];

    var row1 = [
      {
        'plan': this.informacion.plan_estudio,
        'carrera': this.informacion.carrera,
        'modalidad': this.informacion.modalidad
      }
    ];

    var tablas = [];
    var columna2 = [];
    doc.autoTable(columna, row, {
      headStyles: {
        halign: 'center',
        fontSize: 6,
        fillColor: "#D0D3D4",
        textColor: "#000000",

      },

      bodyStyles: {
        fontSize: 6,
        fillColor: "#FFFFFF",
        textColor: "#000000"
      },

      columnStyles: {
        matricula: { cellWidth: 50 },
        nombre: { cellWidth: 90 }
      },
      startY: 25,
      //pageBreak: 'void', 
      theme: 'grid',
    });

    doc.autoTable(columna1, row1, {
      startY: doc.lastAutoTable.finalY,
      headStyles: {
        fontSize: 6,
        fillColor: "#D0D3D4",
        textColor: "#000000",
      },
      bodyStyles: {
        fontSize: 6,
        fillColor: "#FFFFFF",
        textColor: "#000000"
      },
      columnStyles: {
        plan: { cellWidth: 50 },
        carrera: { cellWidth: 90 }
      },
      theme: 'grid',
      // pageBreak: 'avoid',
      //margin: { left: data.cell.x },
      //

    })

    for (let i = 0; i < this.datosKardex.length; i++) {
      /* DECLARACION DE VARIABLES UTILIZADAS DENTRO DEL RECORRIODO Y EXTRACCION DE DATOS DENTRO DE DATA N-1 */
      columna2 = [
        { title: 'CLAVE', dataKey: 'clave' },
        { title: 'CREDITOS', dataKey: 'credito' },
        { title: 'MATERIAS', dataKey: 'materia' },
        { title: 'GRUPO', dataKey: 'grupo' },
        { title: 'PERIODO', dataKey: 'periodo' },
        { title: 'PROMEDIO', dataKey: 'promedio' },
        { title: 'OPC CALIFICACIÓN', dataKey: 'opc' },

      ];

      let niveles = this.datosKardex[i].nivel;
      let nivel_letras = '';


      switch (niveles) {
        case 1:
          nivel_letras = 'PRIMER'
          break;
        case 2:
          nivel_letras = 'SEGUNDO'
          break;
        case 3:
          nivel_letras = 'TERCER'
          break;
        case 4:
          nivel_letras = 'CUARTO'
          break;
        case 5:
          nivel_letras = 'QUINTO'
          break;
        case 6:
          nivel_letras = 'SEXTO'
          break;
        case 7:
          nivel_letras = 'SEPTIMO'
          break;

        case 8:
          nivel_letras = 'OCTAVO'
          break;
        case 9:
          nivel_letras = 'NOVENO'
          break;

        case 10:
          nivel_letras = 'DECIMO'
          break;
        default:
          break;
      }

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8);
      doc.text(nivel_letras + ' ' + this.informacion.modalidad_etiqueta, width / 2, doc.lastAutoTable.finalY + 3, { align: "center" });

      let materias_row = [];
      let data_materias = this.datosKardex[i].materias;

      var clave = '';
      var creditos = null;
      var materia = '';
      var grupo = '';
      var promedio = '';
      var periodo = '';
      var opc = '';
      for (let m = 0; m < data_materias.length; m++) {

        const data_cursamientos = data_materias[m].cursamientos;

        for (let c = 0; c < data_cursamientos.length; c++) {

          if (data_cursamientos[c].promedio_alumno_materia != null) {
            promedio = data_cursamientos[c].promedio_alumno_materia.promedio;
            opc = data_cursamientos[c].promedio_alumno_materia.opcion_nombre + ' ' + data_cursamientos[c].promedio_alumno_materia.opcion_tipo;
          }
          else {
            promedio = '***';
            opc = '***';
          }

          if (data_cursamientos[c].numero_repeticion != 0) {
            clave = data_materias[m].clave_materia;
            creditos = data_materias[m].creditos_materia;
            materia = data_materias[m].nombre_materia + ' - *RECURSAMIENTO*';
            grupo = data_cursamientos[c].grupo;
            periodo = data_cursamientos[c].periodo_escolar;
            materias_row.push(
              {
                'clave': clave,
                'credito': creditos,
                'materia': materia,
                'grupo': grupo,
                'promedio': promedio,
                'periodo': periodo,
                'opc': opc
              }
            )

          } else {
            clave = data_materias[m].clave_materia;
            creditos = data_materias[m].creditos_materia;
            materia = data_materias[m].nombre_materia;
            grupo = data_cursamientos[c].grupo
            periodo = data_cursamientos[c].periodo_escolar;
          }

        }
        clave = data_materias[m].clave_materia;
        creditos = data_materias[m].creditos_materia;
        materia = data_materias[m].nombre_materia;
        materias_row.push(
          {
            'clave': clave,
            'credito': creditos,
            'materia': materia,
            'grupo': grupo,
            'promedio': promedio,
            'periodo': periodo,
            'opc': opc
          }
        )



      }

      tablas = materias_row;



      doc.autoTable(columna2, tablas, {
        didParseCell: data => {


          if (data.row.raw.promedio == '***') {
            data.row.cells.promedio.styles.textColor = [255, 0, 0];
            data.row.cells.promedio.styles.fontStyle = 'bold';
          }
          if (data.row.raw.promedio == '5') {
            data.row.cells.promedio.styles.textColor = [255, 0, 0];
            data.row.cells.promedio.styles.fontStyle = 'bold';
          }

          if (data.row.raw.promedio == '0') {
            data.row.cells.promedio.styles.textColor = [255, 0, 0];
            data.row.cells.promedio.styles.fontStyle = 'bold';
          }

        },
        theme: 'grid',
        startY: doc.lastAutoTable.finalY + 5,
        pageBreak: 'avoid',
        //rowPageBreak:'avoid',
        headStyles: {
          halign: 'center',
          fontSize: 5.5,
          lineColor: "#000000",
          fillColor: "#D0D3D4",
          textColor: "#000000",
        },


        //pageBreak: 'void',
        bodyStyles: {
          fontSize: 6,
          fillColor: "#FFFFFF",
          textColor: "#000000",
          /* halign: 'left', */
        },
        columnStyles: {
          clave: { cellWidth: 15, halign: 'center' },
          credito: { cellWidth: 14, halign: 'center' },
          materia: { cellWidth: 60 },
          grupo: { cellWidth: 13.5, halign: 'center' },
          periodo: { cellWidth: 45 },
          promedio: { cellWidth: 14, halign: 'center' }
        },

        styles: {
          cellPadding: 0.3
        }


      });

    }
    //console.log(height);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    let fecha = 'A ' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
    doc.text(fecha, 198, 268, { align: "right" });
    window.open(doc.output('bloburl'), '_blank');
    //doc.save('KARDEX:' + this.informacion.nombre + '.pdf')
  }


  imprimirHistorial() {
    let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];
    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');

    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();
    let conteo_lienas = 4;
    if (header) {
      header.forEach(element => {
        //console.log(element);
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == "FOTO") {
            doc.addImage(
              item.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            try {
              let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
              contenido =
                "<div style='line-height: 20px;'>" +
                contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                "</div>";

              doc.fromHTML(item.contenido, columna, conteo_lienas, {
                width: ancho + columna
              });
            } catch (e) {
              console.log(e);
            }
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            conteo_lienas += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) conteo_lienas += alto;

      });
    }

    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');

    doc.text('ALUMNO (A): ', 15, 40, { align: "left" });
    doc.text('CARRERA: ', 15, 45, { align: "left" });
    doc.text('MATRICULA: ', 15, 50, { align: "left" });
    doc.text('PLAN DE ESTUDIOS: ', 150, 40, { align: "left" });
    doc.text('MODALIDAD: ', 150, 45, { align: "left" });

    var tAlumno = doc.getTextWidth('ALUMNO (A): ');
    var tCarrera = doc.getTextWidth('CARRERA: ');
    var tMatricula = doc.getTextWidth('MATRICULA: ');
    var tPlan = doc.getTextWidth('PLAN DE ESTUDIOS: ');
    var tModalidad = doc.getTextWidth('MODALIDAD: ');
    //console.log(tAlumno);
    doc.setFont('helvetica', 'bold');
    doc.text(this.configuracion.empresa.nombre + ' ' + this.configuracion.empresa.subnombre, 15, 35);
    doc.text(this.informacion.nombre, 15 + tAlumno, 40, { align: "left" });
    doc.text(this.informacion.carrera, 15 + tCarrera, 45, { align: "left" });
    doc.text(this.informacion.matricula, 15 + tMatricula, 50, { align: "left" });
    doc.text(this.informacion.plan_estudio, 150 + tPlan, 40, { align: "left" });
    doc.text(this.informacion.modalidad, 150 + tModalidad, 45, { align: "left" });

    doc.text('HISTORIAL ACADÉMICO', width / 2, 58, { align: 'center' });

    doc.line(10, 61, 205, 61);
    let tabla = [];
    let columna = [];

    for (let i = 0; i < this.datosKardex.length; i++) {

      let estado = this.datosKardex[i].finalizado;
      let niveles = this.datosKardex[i].nivel;
      let nivel_letras = '';


      switch (niveles) {
        case 1:
          nivel_letras = 'PRIMER'
          break;
        case 2:
          nivel_letras = 'SEGUNDO'
          break;
        case 3:
          nivel_letras = 'TERCER'
          break;
        case 4:
          nivel_letras = 'CUARTO'
          break;
        case 5:
          nivel_letras = 'QUINTO'
          break;
        case 6:
          nivel_letras = 'SEXTO'
          break;
        case 7:
          nivel_letras = 'SEPTIMO'
          break;

        case 8:
          nivel_letras = 'OCTAVO'
          break;
        case 9:
          nivel_letras = 'NOVENO'
          break;

        case 10:
          nivel_letras = 'DECIMO'
          break;
        default:
          break;
      }

      columna = [
        { title: nivel_letras + ' ' + this.informacion.tipo_periodo_etiqueta, dataKey: 'nivel' },
        { title: this.datosKardex[i].periodo_cursado, dataKey: 'periodo' },
        { title: '', dataKey: 'tipo' },
      ];
      let materias_row = [];
      var nombre_materia = '';
      var promedio = '';
      var tipo = '';

      var materia = this.datosKardex[i].materias;
      for (let m = 0; m < materia.length; m++) {
        nombre_materia = materia[m].nombre_materia;
        var cursamientos = materia[m].cursamientos;

        if (cursamientos != 0) {
          for (let i = 0; i < cursamientos.length; i++) {
            let element = cursamientos[0];
            //console.log(element);
            tipo = '';

            if (element.numero_repeticion == 0) {
              if (element.promedio_alumno_materia != null) {
                if (element.promedio_alumno_materia.opcion_nombre != "PROM") {
                  tipo = element.promedio_alumno_materia.opcion_nombre
                }
              }
            } else {
              tipo = 'REC'
            }
            // if (element.numero_repeticion != 0) {
            //   tipo = 'REC'
            // }
            if (estado != 0) {
              if (element.promedio_alumno_materia != null) {
                if (element.promedio_alumno_materia.promedio != null) {
                  promedio = element.promedio_alumno_materia.promedio;
                } else {
                  promedio = '/';
                }
              } else {
                promedio = '/';
              }
            } else {
              promedio = '/';
            }

          }
        } else {
          promedio = '/';
        }


        materias_row.push({
          'nivel': nombre_materia,
          'periodo': promedio,
          'tipo': tipo
        });
      }
      tabla = materias_row;
      //console.log(doc.lastAutoTable);

      if (i % 2 != 0) {

        doc.autoTable(columna, tabla, {
          didParseCell: data => {
            //console.log(data);
            if (data.row.raw.periodo == '--') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
            if (data.row.raw.periodo == '0') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
            if (data.row.raw.periodo == '5') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
          },
          startY: 48 + (17 * i),
          theme: 'plain',
          tableWidth: 90,
          margin: { left: 110 },
          styles: {
            fontSize: 6,
            cellPadding: 0.2
          },
          headStyles: {
            textColor: [0, 0, 0],
            halign: 'center'
          },
          bodyStyles: {
            textColor: [0, 0, 0]
          },
          columnStyles: {
            nivel: { cellWidth: 45, halign: 'left' },
            periodo: { cellWidth: 40, halign: 'center' },
            tipo: { cellWidth: 10, halign: 'center' },

          },

        });
      } else {

      }

      if (i % 2 == 0) {

        doc.autoTable(columna, tabla, {
          didParseCell: data => {
            // console.log(data);
            if (data.row.raw.periodo == '--') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
            if (data.row.raw.periodo == '0') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
            if (data.row.raw.periodo == '5') {
              data.row.cells.periodo.styles.textColor = [255, 0, 0];
              data.row.cells.periodo.styles.fontStyle = 'bold';
            }
          },
          startY: 65 + (17 * i),
          theme: 'plain',
          tableWidth: 90,
          margin: { right: 110 },
          styles: {
            fontSize: 6,
            cellPadding: 0.2
          },
          headStyles: {
            textColor: [0, 0, 0],
            halign: 'center'
          },
          bodyStyles: {
            textColor: [0, 0, 0]
          },
          columnStyles: {
            nivel: { cellWidth: 45, halign: 'left' },
            periodo: { cellWidth: 40, halign: 'center' },
            tipo: { cellWidth: 10, halign: 'center' },
          },
        });
      } else {

      }

    }
    doc.setFont('helvetica', '', 'normal');
    doc.setFontSize(7);
    doc.text('ACREDITANDO ' + this.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + this.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + this.informacion.promedio_general, 10, doc.lastAutoTable.finalY + 10);
    if (footer) {
      footer.forEach(element => {
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == 'CONTENIDO') {
            let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
            contenido =
              "<div style='line-height: 20px;'>" +
              contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
              "</div>";
            doc.fromHTML(item.contenido, columna, doc.lastAutoTable.finalY + 5, {
              width: ancho + columna
            });
          }
          //console.log(columna = ancho + 1);
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            doc.lastAutoTable.finalY += alto;
            columna = 5;
            col_no = 1;
          }
        });
      });
    }
    doc.setFontSize(7);
    doc.setFont('helvetica', '', 'normal');
    let fecha = 'A ' + nombre_dia.toUpperCase() + ' ,' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
    doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 272, { align: "right" });
    window.open(doc.output('bloburl'), '_blank');
  }
  datosParciales = {
    nivel: 0,
    promedio_nivel: {
      promedio: ''
    },
    nivel_tiene_practica: 0,
    materias: [],
    periodo_cursado: ''

  };

  borrarmov;
  rutamov;

  // borrarMovimiento(item) {
  //   console.log(item);
  //   this.borrarmov = item;
  //   //this.rutamov = ruta;
  //   document.getElementById("confirmarEliminarMov").classList.add("is-active");
  // }

  // confirmacionEliminar(item) {
  //   console.log(item);
  //   this.http.post('https://cum.api.managerescolar.app/api/v1/eliminar-pago-expediente-historial/', item).subscribe((resultado:any) => {
  //     //console.log(resultado);
  //     if (resultado.status == 200) {
  //       this.titulo = 'PAGO ELIMINADO';
  //       this.mensaje = resultado.messages;
  //       this.clase = 'success';
  //       this.cancelarModal('confirmarEliminarMov');
  //     }else{
  //       this.clase = 'warning';
  //     }
  //   }, e => {
  //     console.log(e);
  //     this.cargando = false;
  //     this.titulo = 'Error';
  //     this.mensaje = e.error.messages
  //     this.clase = "error";
  //     this.cancelarModal('confirmarEliminarMov');
  //     document.getElementById("message").click();
  //   })


  // }
  datoCalificaciones = []

  verParcial(element) {
    for (let i = 0; i < this.datosKardex.length; i++) {
      if (this.datosKardex[i].nivel === element) {
        this.datosParciales = this.datosKardex[i];
      }
    }

    for (let j = 0; j < this.datosParciales.materias.length; j++) {
      const cursamientos = this.datosParciales.materias[j].cursamientos;

      for (let c = 0; c < cursamientos.length; c++) {
        this.datoCalificaciones = cursamientos[0].calificaciones;
      }

    }
  }


  datosColegiaturas = [];
  datosInscripciones = [];
  datosMovimientos = [];
  verMovimiento(element) {
    console.log(element);
    for (let index = 0; index < this.datosFinancieros.length; index++) {
      const financieros = this.datosFinancieros[index];

      if (financieros.movimientos.id === element) {
        if (financieros.movimientos.movimientos_colegiaturas != null) {
          this.datosColegiaturas = financieros.movimientos.movimientos_colegiaturas;
        }

        if (financieros.movimientos.movimientos_inscripciones != null) {
          this.datosInscripciones = financieros.movimientos.movimientos_inscripciones;
        }

        this.datosMovimientos = this.datosColegiaturas.concat(this.datosInscripciones);


      }

    }

    // console.log(this.datosMovimientos);

  }

  ReimprimirT(item) {
    let paginaAlto = 350;
    paginaAlto = paginaAlto + (item.movimientos.movimientos_articulos.length * 10);

    console.log(item);
    let doc = new jsPDF("p", "mm", [200, paginaAlto]);
    //let imgData = 'data:image/jpeg;base64,' + item.movimientos.barcode;
    doc.setFontSize(9);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.empresa.nombre, 35, 6, { align: "center" });

    doc.setFontSize(8);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0], 35, 10, { align: "center" });
    doc.text(this.configuracion.sucursal.direccion.split(",")[1], 35, 13, { align: "center" });
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc, 35, 18, { align: "center" });

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    doc.text('--------------------------------------------------', 35, 23, { align: 'center' });

    doc.setFontSize(7);
    doc.text('Campus: ' + this.configuracion.sucursal.nombre, 35, 27, { align: 'center' });
    doc.setFont("courier", "", "bold");
    doc.text('Teléfono', 35, 30, { align: 'center' });
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.telefono, 35, 33, { align: "center" });
    doc.setFont("courier", "", "bold");
    doc.text('Correo', 35, 36, { align: 'center' });
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.correo, 35, 39, { align: "center" });

    doc.setFontSize(6);
    doc.text('--------------------------------------------------', 35, 43, { align: 'center' });
    // doc.setFontSize(8);
    doc.setFontSize(7);

    doc.text('CÓDIGO: ' + item.movimientos.codigo, 67, 48, { align: 'right' });
    doc.text('FECHA: ' + item.created_at, 67, 52, { align: 'right' });

    doc.text("CLIENTE: " + this.alumnos.nombre + ' ' + this.alumnos.apellido_paterno + ' ' + this.alumnos.apellido_materno, 69, 56, { align: "right" });

    doc.setFontSize(6);
    doc.text('--------------------------------------------------', 35, 60, { align: 'center' });

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('DETALLE', 35, 66, { align: 'center' });
    doc.text('CANT.', 5, 71, { align: 'left' });
    doc.text('PRECIO', 14, 71, { align: 'left' });
    doc.text('DESCUENTO', 32, 71, { align: 'left' });
    doc.text('IMPORTE', 50, 71, { align: 'left' });

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    let lineaY = 73;


    for (let k in item.movimientos.movimientos_articulos) {
      doc.text("ARTICULO: ", 5, lineaY, { align: "left" });
      doc.text(item.movimientos.movimientos_articulos[k].articulos.nombre, 18, lineaY, { align: 'left' });
      lineaY = lineaY + 3;
      doc.text(item.movimientos.movimientos_articulos[k].cantidad, 5, lineaY, { align: 'left' });
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_unitario), 14, lineaY, { align: 'left' });
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].descuento), 45, lineaY, { align: 'right' });
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_con_descuentos), 64, lineaY, { align: 'right' });

      lineaY = lineaY + 2;
      doc.text("--------------------------------------------------", 35, lineaY, { align: "center" });

      lineaY = lineaY + 3;
    }

    lineaY = (lineaY - 3) + 5;

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('SUBTOTAL: ' + this.convertirMoneda(item.movimientos.subtotal), 67, lineaY, { align: 'right' });
    lineaY = lineaY + 4;
    doc.text('DESCUENTO: ' + this.convertirMoneda(item.movimientos.descuento), 67, lineaY, { align: 'right' });
    lineaY = lineaY + 4;
    doc.text('TOTAL: ' + this.convertirMoneda(item.movimientos.total), 67, lineaY, { align: 'right' });
    lineaY = lineaY + 4;
    doc.text(item.tipos_formas_pagos.nombre.toUpperCase() + ": " + this.convertirMoneda(item.paga_con), 67, lineaY, { align: 'right' });
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text("CAMBIO: " + this.convertirMoneda(item.cambio), 67, lineaY, { align: 'right' });
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text(item.tipos_metodos_pagos.nombre.toUpperCase(), 67, lineaY, { align: 'right' });

    doc.setFontSize(6);
    lineaY = lineaY + 5;
    doc.text('--------------------------------------------------', 35, lineaY, { align: 'center' });
    doc.setFontSize(6);
    lineaY = lineaY + 4;
    if (this.configuracion.sucursal.imprimir_usuario_ticket) {
      doc.text('Atendió: ' + item.movimientos.usuarios.nombre, 35, lineaY, { align: 'center' });
      lineaY = lineaY + 4;
    }
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    doc.text(this.configuracion.sucursal.mensaje ? this.configuracion.sucursal.mensaje : 'Gracias por su pago', 35, lineaY, { align: "center" });
    lineaY = lineaY + 2;
    //doc.addImage(imgData, 'JPEG', 15, lineaY, 40, 3, 'center');


    window.open((doc as any).output('bloburl'), '_blank');
  }

  obtenerDocumentos(tipo) {
    this.crud.lista(this.parametros, "documentos?tipo=" + tipo)
      .subscribe(resultado => {
        if (resultado.status == 200) {
          this.documentos[tipo] = resultado.data;
        }
      })
  }
  imprimirParcial() {
    let header = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    let footer = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];
    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');
    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();
    let linealY = 5;
    if (header) {
      header.forEach(element => {
        //console.log(element);
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == "FOTO") {
            doc.addImage(
              item.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            try {
              let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
              contenido =
                "<div style='line-height: 20px;'>" +
                contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                "</div>";

              doc.fromHTML(item.contenido, columna, linealY, {
                width: ancho + columna
              });
            } catch (e) {
              console.log(e);
            }
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            linealY += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) linealY += alto;
      });
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "", "bold");
    linealY -= 3;
    doc.text('BOLETA PARCIAL', width / 2, linealY, { align: 'center' });
    linealY += 10;
    doc.setFontSize(8);

    doc.text('NIVEL: ', 10, linealY, { align: 'left' });
    doc.text('TURNO: ', 125, linealY, { align: 'left' });
    doc.text(this.alumnos.carreras.nivel_educativo.toUpperCase(), 30, linealY, { align: 'left' });
    doc.text(this.alumnos.grupos.turnos.nombre, 145, linealY, { align: 'left' });
    doc.line(25, linealY + 1, 120, linealY + 1);
    doc.line(140, linealY + 1, 206, linealY + 1);

    doc.text('CLAVE: ', 10, linealY + 10, { align: 'left' });
    doc.text('CICLO: ', 125, linealY + 10, { align: 'left' });
    doc.text(this.alumnos.carreras.sigla, 30, linealY + 10, { align: 'left' });
    doc.text(this.datosParciales.periodo_cursado.toUpperCase(), 145, linealY + 10, { align: 'left' });
    doc.line(25, linealY + 11, 120, linealY + 11);
    doc.line(140, linealY + 11, 206, linealY + 11);


    doc.text('CARRERA: ', 10, linealY + 5, { align: 'left' });
    doc.text(this.informacion.carrera + ' - ' + this.informacion.plan_estudio, 30, linealY + 5);
    doc.line(25, linealY + 6, 206, linealY + 6);



    doc.text('NOMBRE: ', 10, linealY + 18, { align: 'left' });
    doc.text('MATRICULA: ', 125, linealY + 18, { align: 'left' });
    doc.text(this.informacion.nombre, 30, linealY + 18, { align: 'left' });
    doc.text(this.informacion.matricula, 145, linealY + 18, { align: 'left' });
    doc.line(25, linealY + 19, 120, linealY + 19);
    doc.line(145, linealY + 19, 206, linealY + 19);


    doc.text(this.informacion.modalidad_etiqueta + ': ', 10, linealY + 23, { align: 'left' });
    doc.text('GRUPO: ', 125, linealY + 23, { align: 'left' });
    doc.text(this.datosParciales.nivel.toString(), 40, linealY + 23, { align: 'left' });
    doc.text(this.alumnos.grupos.clave + '-' + this.datosParciales.nivel.toString() + this.alumnos.grupos.identificador, 145, linealY + 23, { align: 'left' });
    doc.line(35, linealY + 24, 120, linealY + 24);
    doc.line(140, linealY + 24, 206, linealY + 24);

    linealY += 38;
    let tabla = [];
    let columna = [{ title: 'N', dataKey: 'id' },
    { title: 'Materias', dataKey: 'materias' },];
    let materias_row = [];

    /*   for (let index = 1; index <= this.informacion.numero_parciales; index++) {
        columna.push({
          title: 'Parcial ' + index,
          dataKey: 'parcial' + index
        });
      }  */

    for (let c = 0; c < this.datoCalificaciones.length; c++) {
      const element = this.datoCalificaciones[c];
      if (element.numero_parcial > 0) {
        columna.push({
          title: 'Parcial ' + element.numero_parcial,
          dataKey: 'parcial' + element.numero_parcial
        });
      }


    }
    if (this.datosParciales.nivel_tiene_practica != 0) {
      columna.push({
        title: 'Practica ',
        dataKey: 'practica'
      })
    }

    for (let m = 0; m < this.datosParciales.materias.length; m++) {
      let dato_boleta = {};
      let data_materia = this.datosParciales.materias[m];
      let dato_cursamiento = this.datosParciales.materias[m].cursamientos;
      dato_boleta['id'] = m + 1;
      dato_boleta['materias'] = data_materia.nombre_materia;

      if (dato_cursamiento != 0) {
        for (let c = 0; c < dato_cursamiento.length; c++) {
          let data_calificaciones = dato_cursamiento[0].calificaciones;
          //console.log(data_calificaciones);
          if (data_calificaciones != 0) {
            for (let d = 0; d < data_calificaciones.length; d++) {

              let element = data_calificaciones[d]
              if (element.numero_parcial > 0) {
                if (element.calificacion != null) {
                  dato_boleta['parcial' + element.numero_parcial] = element.calificacion;
                } else {
                  dato_boleta['parcial' + element.numero_parcial] = '0';
                }
              }

              if (element.numero_parcial == 0) {
                if (element.calificacion != null) {
                  dato_boleta['practica'] = element.calificacion;
                } else {
                  dato_boleta['practica'] = '0'
                }
              }

            }
          }
        }
      }


      materias_row.push(dato_boleta);
    }

    tabla = materias_row;

    doc.autoTable(columna, tabla, {
      startY: linealY,
      theme: 'grid',
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.3,
      margin: { right: 10, left: 10 },
      headStyles: {
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
      },
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        halign: 'center',
        fillColor: [255, 255, 255],
        fontSize: 8,
        font: "helvetica",
        textColor: [0, 0, 0]
      },

      columnStyles: {
        materias: { halign: 'left' }
      }
    });

    doc.setFontSize(8);
    doc.setFont('helvetica', '', 'normal');
    //doc.text('PROMEDIO: ' + this.datosParciales.promedio_nivel.promedio, 195, doc.lastAutoTable.finalY + 10, { align: 'right' })

    if (footer) {
      footer.forEach(element => {
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == 'CONTENIDO') {
            let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
            contenido =
              "<div style='line-height: 20px;'>" +
              contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
              "</div>";
            doc.fromHTML(item.contenido, columna, doc.lastAutoTable.finalY + 15, {
              width: ancho + columna
            });
          }
          //console.log(columna = ancho + 1);
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            doc.lastAutoTable.finalY += alto;
            columna = 5;
            col_no = 1;
          }
        });
      });
    }
    doc.setFontSize(7.5);
    doc.setFont('helvetica', '', 'normal');
    let fecha = 'A ' + nombre_dia.toUpperCase() + ' ,' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
    doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 268, { align: "right" });

    window.open(doc.output('bloburl'), '_blank');

  }

  imprimirBoleta() {
    let header = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    let footer = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];
    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');
    let doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'letter'
    });
    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();
    /* const getBase64Image = (url) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        console.log(dataURL)
      }
      img.src = url
    }

    console.log(getBase64Image(this.alumnos.carreras.logo)); */



    let linealY = 5;
    if (header) {
      header.forEach(element => {
        //console.log(element);
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == "FOTO") {
            doc.addImage(
              item.logo,
              "PNG",
              columna,
              fila,
              ancho,
              alto,
              "",
              "FAST"
            );
          } else {
            try {
              let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
              contenido =
                "<div style='line-height: 20px;'>" +
                contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                "</div>";

              doc.fromHTML(item.contenido, columna, linealY, {
                width: ancho + columna
              });
            } catch (e) {
              console.log(e);
            }
          }
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            linealY += alto;
            columna = 5;
            col_no = 1;
          }
        });
        if (col_no == 0) linealY += alto;

      });
    }

    //console.log(linealY);
    doc.setFontSize(12);
    doc.setFont("helvetica", "", "bold");
    linealY -= 3;
    doc.text('BOLETA ' + this.informacion.modalidad, width / 2, linealY, { align: 'center' });
    linealY += 10;
    doc.setFontSize(8);

    doc.text('NIVEL: ', 10, linealY, { align: 'left' });
    doc.text('TURNO: ', 125, linealY, { align: 'left' });
    doc.text(this.alumnos.carreras.nivel_educativo.toUpperCase(), 30, linealY, { align: 'left' });
    doc.text(this.alumnos.grupos.turnos.nombre, 145, linealY, { align: 'left' });
    doc.line(25, linealY + 1, 120, linealY + 1);
    doc.line(140, linealY + 1, 206, linealY + 1);

    doc.text('CLAVE: ', 10, linealY + 10, { align: 'left' });
    doc.text('CICLO: ', 125, linealY + 10, { align: 'left' });
    doc.text(this.alumnos.carreras.sigla, 30, linealY + 10, { align: 'left' });
    doc.text(this.datosParciales.periodo_cursado.toUpperCase(), 145, linealY + 10, { align: 'left' });
    doc.line(25, linealY + 11, 120, linealY + 11);
    doc.line(140, linealY + 11, 206, linealY + 11);


    doc.text('CARRERA: ', 10, linealY + 5, { align: 'left' });
    doc.text(this.informacion.carrera + ' - ' + this.informacion.plan_estudio, 30, linealY + 5);
    doc.line(25, linealY + 6, 206, linealY + 6);



    doc.text('NOMBRE: ', 10, linealY + 18, { align: 'left' });
    doc.text('MATRICULA: ', 125, linealY + 18, { align: 'left' });
    doc.text(this.informacion.nombre, 30, linealY + 18, { align: 'left' });
    doc.text(this.informacion.matricula, 145, linealY + 18, { align: 'left' });
    doc.line(25, linealY + 19, 120, linealY + 19);
    doc.line(145, linealY + 19, 206, linealY + 19);


    doc.text(this.informacion.modalidad_etiqueta + ': ', 10, linealY + 23, { align: 'left' });
    doc.text('GRUPO: ', 125, linealY + 23, { align: 'left' });
    doc.text(this.datosParciales.nivel.toString(), 40, linealY + 23, { align: 'left' });
    doc.text(this.alumnos.grupos.clave + '-' + this.datosParciales.nivel.toString() + this.alumnos.grupos.identificador, 145, linealY + 23, { align: 'left' });
    doc.line(35, linealY + 24, 120, linealY + 24);
    doc.line(140, linealY + 24, 206, linealY + 24);

    let tabla = [];
    let columna = [
      { title: 'N', dataKey: 'id' },
      { title: 'Materias', dataKey: 'materias' },
      { title: 'Promedio', dataKey: 'promedio' },
    ];
    let materias_row = [];
    var nombre_materia = '';
    let linea_materia = 0;
    let tamanio_calificacion = 0;

    for (let i = 0; i < this.datosParciales.materias.length; i++) {
      let cursamientos = this.datosParciales.materias[i].cursamientos;
      let calific = {};
      calific['materias'] = this.datosParciales.materias[i].nombre_materia;
      calific['id'] = i + 1

      if (cursamientos != 0) {
        for (let c = 0; c < cursamientos.length; c++) {
          const element = cursamientos[0].promedio_alumno_materia;

          if (element != null) {
            if (element.promedio != null) {
              calific['promedio'] = element.promedio;
            } else {
              calific['promedio'] = '5';
            }
          } else {
            calific['promedio'] = '5';
          }

        }
      }


      materias_row.push(calific);
    }

    linealY += 38

    doc.autoTable(columna, materias_row, {
      startY: linealY,
      theme: 'grid',
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.3,
      margin: { right: 10, left: 10 },
      headStyles: {
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
      },
      /* bodyStyles: {
        textColor: [0, 0, 0],
        fontSize: 7
      }, */

      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        halign: 'center',
        fillColor: [255, 255, 255],
        fontSize: 8,
        font: "helvetica",
        textColor: [0, 0, 0]
      },

      columnStyles: {
        materias: { halign: 'left' }
      }


    });




    doc.setFontSize(8);
    doc.setFont('helvetica', '', 'normal');
    doc.text('PROMEDIO: ' + this.datosParciales.promedio_nivel.promedio, 195, doc.lastAutoTable.finalY + 10, { align: 'right' })

    if (footer) {
      footer.forEach(element => {
        let columna = 10;
        let fila = 5;
        let col = 0;
        let fil = 0;
        let col_no = 0;
        let ancho = 0;
        let alto = 0;
        element.estructuras_contenidos.forEach(item => {
          ancho = 216 * (item.ancho_porcentaje / 100);
          alto = 279 * (item.alto_porcentaje / 100);
          col_no = 0;

          if (item.tipo == 'CONTENIDO') {
            let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
            contenido =
              "<div style='line-height: 20px;'>" +
              contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
              "</div>";
            doc.fromHTML(item.contenido, columna, doc.lastAutoTable.finalY + 15, {
              width: ancho + columna
            });
          }
          // console.log(columna = ancho + 1);
          columna += ancho + 1;
          col++;

          if (element.columnas == col) {
            col = 0;
            doc.lastAutoTable.finalY += alto;
            columna = 5;
            col_no = 1;
          }
        });
      });
    }
    doc.setFontSize(8);
    doc.setFont('helvetica', '', 'normal');
    let fecha = 'A ' + nombre_dia.toUpperCase() + ' ,' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
    doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 268, { align: "right" });
    window.open(doc.output('bloburl'), '_blank');
  }


  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.nombre} ${data.apellido_paterno
      } ${data.apellido_materno}
            <small style="font-size: .5em; font-style: italic;">
           ${data.email}
            </small></h4>
            <h6>
              <strong>CURP: </strong> ${data.curp
      } <strong>Tutor: </strong> ${data.alumnos_metadatos.tutor_nombre}
              `;
    // MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA 

    html += `<label class="tag is-success" >Matrícula: <strong>${data.matricula
      } </strong> </label>`;

    html += `<label class="tag is-warning" >  ${data.carreras.nombre
      }</label>`;

    // MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA 

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  /**
   * Funcion buscar se cancela el autocompletar
   */

  resultados: any = [];
  buscar(item) {
    this.buscando = true;
    if (this.alumnos.alumnos_metadatos.nombre != '') {
      this.alumnos.alumnos_metadatos.nombre = '';
      this.buscar(item)
    } else {
      this.observableSource(item).subscribe((resultado) => {
        //console.log(resultado);
        this.resultados = resultado;
        this.buscando = false;
      })
    }


  }
  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data) {

    //!this.cargando = true; /* <---- quitado*/
    this.auto = 0;

    if (!data.alumnos_metadatos.hasOwnProperty("foto")) {
      data.alumnos_metadatos.foto = "";
    }
    if (!data.alumnos_metadatos.hasOwnProperty("avatar")) {
      data.alumnos_metadatos.avatar = "";
    }
    this.alumnos = data;
    // console.log(this.alumnos);  
    document.getElementById("catalogos").click();
    this.cargarDatos(this.alumnos.id);
    // (<HTMLInputElement>document.getElementById("buscarArticulo")).value = "";
  }
  periodos_escolares_seleccionado;
  cargarGrupos(e) {
    this.periodos_escolares_seleccionado = e;
    document.getElementById("cargar_grupos").click();
  }

  cargarDatos(id) {
    this.dato = [];
    this.mensualidades = [];
    this.carrera_modulo_nivel = [];
    this.carrera_plan = [];
    this.cargando = true;
    this.crud.ver(this.alumnos.id, "alumno-operacion/reporte").subscribe(
      resultado => {
        //console.log(resultado);

        if (resultado.status == 200) {


          if (resultado.alumno) {
            this.alumnos = resultado.alumno;
            this.resultados = [];
          }


          if (resultado.alumno != null) {
            this.datos_personales = resultado.alumno;
            // this.datos_adicionales = resultado.alumno.datos_adicionales;
            let domicilio_estado = '';
            let domicilio_municipio = '';
            let domicilio_colonia = '';
            let domicilio_calle = '';
            let domicilio_exterior = '';
            let domicilio_interior = '';
            let domicilio_referencias = '';
            let tipo_sangre = '';
            let factor_rh = '';
            let alergias = '';
            let presenta_alergias = '';
            let contacto_medico = '';
            let telefono_medico = '';
            let telefono_medico2 = '';
            let padecimientos = '';
            let observaciones2 = '';
            let nombre_tutor = ''
            let nombre_tutor2 = ''
            let parentesco = ''
            let parentesco_2 = ''
            let observaciones = ''
            let email = ''
            let email2 = ''
            let tel = ''
            let tel2 = ''

            let datos_a: any = [];
            let datos_t: any = [];

            if (resultado.alumno.datos_adicionales != null) {
              datos_a = resultado.alumno.datos_adicionales;

              if (datos_a.domicilio_estado != null) {
                domicilio_estado = datos_a.domicilio_estado
              } else {
                domicilio_estado = ''
              }

              if (datos_a.domicilio_municipio != null) {
                domicilio_municipio = datos_a.domicilio_municipio
              } else {
                domicilio_municipio = ''
              }

              if (datos_a.domicilio_colonia != null) {
                domicilio_colonia = datos_a.domicilio_colonia
              } else {
                domicilio_colonia = ''
              }

              if (datos_a.domicilio_calle != null) {
                domicilio_calle = datos_a.domicilio_calle
              } else {
                domicilio_calle = ''
              }

              if (datos_a.domicilio_exterior != null) {
                domicilio_exterior = datos_a.domicilio_exterior
              } else {
                domicilio_exterior = ''
              }

              if (datos_a.domicilio_interior != null) {
                domicilio_interior = datos_a.domicilio_interior
              } else {
                domicilio_interior = ''
              }

              if (datos_a.domicilio_referencias != null) {
                domicilio_referencias = datos_a.domicilio_referencias
              } else {
                domicilio_referencias = ''
              }

              if (datos_a.tipo_sangre != null) {
                tipo_sangre = datos_a.tipo_sangre
              } else {
                tipo_sangre = ''
              }

              if (datos_a.factor_rh != null) {
                factor_rh = datos_a.factor_rh
              } else {
                factor_rh = ''
              }

              if (datos_a.alergias != null) {
                alergias = datos_a.alergias
              } else {
                alergias = ''
              }

              if (datos_a.presenta_alergias != null) {
                presenta_alergias = datos_a.presenta_alergias
              } else {
                presenta_alergias = '2'
              }

              if (datos_a.padecimientos != null) {
                padecimientos = datos_a.padecimientos
              } else {
                padecimientos = ''
              }

              if (datos_a.contacto_medico != null) {
                contacto_medico = datos_a.contacto_medico
              } else {
                contacto_medico = ''
              }

              if (datos_a.telefono_medico != null) {
                telefono_medico = datos_a.telefono_medico
              } else {
                telefono_medico = ''
              }

              if (datos_a.telefono_medico2 != null) {
                telefono_medico2 = datos_a.telefono_medico2
              } else {
                telefono_medico2 = ''
              }

              this.datos_adicionales = {
                domicilio_estado: domicilio_estado,
                domicilio_municipio: domicilio_municipio,
                domicilio_colonia: domicilio_colonia,
                domicilio_calle: domicilio_calle,
                domicilio_exterior: domicilio_exterior,
                domicilio_interior: domicilio_interior,
                domicilio_referencias: domicilio_referencias,
                tipo_sangre: tipo_sangre,
                factor_rh: factor_rh,
                alergias: alergias,
                presenta_alergias: presenta_alergias,
                contacto_medico: contacto_medico,
                telefono_medico: telefono_medico,
                telefono_medico2: telefono_medico2,
                padecimientos: padecimientos,
                observaciones: observaciones
              };
              
            } else {
              domicilio_estado = '',
                domicilio_municipio = '',
                domicilio_colonia = '',
                domicilio_calle = '',
                domicilio_exterior = '',
                domicilio_interior = '',
                domicilio_referencias = '',
                tipo_sangre = '',
                factor_rh = '',
                alergias = '',
                presenta_alergias = '2',
                contacto_medico = '',
                telefono_medico = '',
                telefono_medico2 = '',
                padecimientos = '',
                observaciones = ''
            }

            if (resultado.alumno.datos_tutores != null) {
              datos_t = resultado.alumno.datos_tutores;
              if (datos_t.nombre != null) {
                nombre_tutor = datos_t.nombre
              } else {
                nombre_tutor = '';
              }
              if (datos_t.nombre2 != null) {
                nombre_tutor2 = datos_t.nombre2
              } else {
                nombre_tutor2 = ''
              }

              if (datos_t.parentesco != null) {
                parentesco = datos_t.parentesco
              } else {
                parentesco = ''
              }

              if (datos_t.telefono != null) {
                tel = datos_t.telefono
              } else {
                tel = ''
              }

              if (datos_t.telefono2 != null) {
                tel2 = datos_t.telefono2
              } else {
                tel2 = ''
              }

              if (datos_t.email != null) {
                email = datos_t.email
              } else {
                email = ''
              }

              if (datos_t.email2 != null) {
                email2 = datos_t.email2
              } else {
                email2 = ''
              }



              if (datos_t.parentesco != null) {
                parentesco = datos_t.parentesco
              } else {
                parentesco = ''
              }

              if (datos_t.parentesco2 != null) {
                parentesco_2 = datos_t.parentesco2
              } else {
                parentesco_2 = '';
              }

              if (datos_t.observaciones != null) {
                observaciones = datos_t.observaciones
              } else {
                observaciones = ''
              }

              if (datos_a.observaciones != null) {
                observaciones2 = datos_a.observaciones
              } else {
                observaciones2 = ''
              }
              
            this.datos_tutores = {
              nombre: nombre_tutor,
              parentesco: parentesco,
              email: resultado.alumno.datos_tutores.email,
              telefono: resultado.alumno.datos_tutores.telefono,
              nombre2: nombre_tutor2,
              parentesco2: parentesco_2,
              email2: resultado.alumno.datos_tutores.email2,
              telefono2: resultado.alumno.datos_tutores.telefono2,
              observaciones: observaciones
            }

            } 

         

          } else {
            this.datos_personales = {
              nombre: '',
              apellido_paterno: '',
              apellido_materno: '',
              curp: '',
              fecha_nacimiento: '',
              sexo: 'M',
              telefono: '',
              telefono2: '',
              email: '',
              tiene_whatsapp: 0,
              tiene_whatsapp2: 0,
              reset_contrasenia: 0
            };

            this.datos_adicionales = {
              domicilio_estado: '',
              domicilio_municipio: '',
              domicilio_colonia: '',
              domicilio_calle: '',
              domicilio_exterior: '',
              domicilio_interior: '',
              domicilio_referencias: '',
              tipo_sangre: '',
              factor_rh: '',
              alergias: '',
              presenta_alergias: '2',
              contacto_medico: '',
              telefono_medico: '',
              telefono_medico2: '',
              padecimientos: '',
              observaciones: ''
            };

            this.datos_tutores = {
              nombre: '',
              parentesco: '',
              telefono: '',
              email: '',
              nombre2: '',
              parentesco2: '',
              telefono2: '',
              email2: '',
              observaciones: ''
            };
          }
          this.kardex = resultado.kardex;
          this.finanza = resultado.finanza;
          this.conducta = resultado.conducta;
          this.carreras_planes = resultado.carreras_planes;
          this.periodos_escolares = resultado.periodos_escolares;
          this.carrera_modulo_nivel = resultado.carrera_modulo_nivel;
          this.personas_historial_bajas = resultado.personas_historial_bajas;
          this.alumnos.alumnos_inicializacion = resultado.alumnos_inicializacion;
          this.lista_cupones = resultado.personas_cupones;
          this.lista_inscripciones_grupos_siguientes = resultado.inscripciones_grupos_siguientes;
          this.lista_incidencias = resultado.personas_incidencias;
          this.estatus_alumno = resultado.estatus_alumno

          if (this.alumnos.grupos["periodos_escolares"]["tipos_periodos"]) {
            for (let i = 1; i <= this.alumnos.grupos["periodos_escolares"]["tipos_periodos"].duracion_meses; i++) {
              this.mensualidades.push(i);
            }
          }

          this.datos_personalesF = this.fb.group({
            id: [this.alumnos.id],
            nombre: [this.datos_personales.nombre, [Validators.required]],
            apellido_paterno: [this.datos_personales.apellido_paterno, [Validators.required]],
            apellido_materno: [this.datos_personales.apellido_materno, [Validators.required]],
            curp: [this.datos_personales.curp],
            fecha_nacimiento: [this.datos_personales.fecha_nacimiento],
            sexo: [this.datos_personales.sexo],
            telefono: [this.datos_personales.telefono],
            telefono2: [this.datos_personales.telefono2],
            email: [this.datos_personales.email, [Validators.required]],
            tiene_whatsapp: [this.datos_personales.tiene_whatsapp],
            tiene_whatsapp2: [this.datos_personales.tiene_whatsapp2],
            reset_contrasenia: [this.datos_personales.reset_contrasenia],
            datos_adicionales: this.fb.group({
              domicilio_estado: [this.datos_adicionales.domicilio_estado],
              domicilio_municipio: [this.datos_adicionales.domicilio_municipio],
              domicilio_colonia: [this.datos_adicionales.domicilio_colonia],
              domicilio_calle: [this.datos_adicionales.domicilio_calle],
              domicilio_exterior: [this.datos_adicionales.domicilio_exterior],
              domicilio_interior: [this.datos_adicionales.domicilio_interior],
              domicilio_referencias: [this.datos_adicionales.domicilio_referencias],
              tipo_sangre: [this.datos_adicionales.tipo_sangre],
              factor_rh: [this.datos_adicionales.factor_rh],
              alergias: [this.datos_adicionales.alergias],
              presenta_alergias: [this.datos_adicionales.presenta_alergias],
              contacto_medico: [this.datos_adicionales.contacto_medico],
              telefono_medico: [this.datos_adicionales.contacto_medico],
              telefono_medico2: [this.datos_adicionales.telefono_medico2],
              padecimientos: [this.datos_adicionales.padecimientos],
              observaciones: [this.datos_adicionales.observaciones]
            }),
            datos_tutores: this.fb.group({
              nombre: [this.datos_tutores.nombre],
              parentesco: [this.datos_tutores.parentesco],
              telefono: [this.datos_tutores.telefono],
              email: [this.datos_tutores.email],
              nombre2: [this.datos_tutores.nombre2],
              parentesco2: [this.datos_tutores.parentesco2],
              telefono2: [this.datos_tutores.telefono2],
              email2: [this.datos_tutores.email2],
              observaciones: [this.datos_tutores.observaciones]
            }),
          });
          let inscripcion = null;
          /*  if (this.finanza.data.length > 0) {
             inscripcion = this.finanza.data[this.finanza.data.length - 1].id; 
           }*/
          this.data = this.fb.group({
            id: [this.alumnos.id],
            alumnos_inicializacion: this.fb.group({
              nivel: [1],
              mes: [0],
              inicializado: [1],
              completado: [0],
              ultimo_abono: ['']
            }),

            personas_historial_bajas: this.fb.group({
              personas_id: [this.alumnos.id],
              inscripciones_id: [inscripcion],
              tipos_bajas_id: ['', [Validators.required]],
              fecha_baja: ['', [Validators.required]],
              observaciones: [''],
              invalidar_inicializacion: ['0']
            }),
            personas_rfcs: this.fb.array([]),
            personas_cupones: this.fb.array([]),
            inscripciones_grupos_siguientes: this.fb.array([]),
            personas_incidencias: this.fb.array([])
          });
          if (resultado.personas_rfcs.length > 0) {
            let rfc = <FormArray>this.data.controls.personas_rfcs;
            resultado.personas_rfcs.forEach(element => {
              rfc.push(this.fb.group(element));
            });
          }

        } else {
          this.titulo = "No configurado";
          this.mensaje = "No se encontro datos";
          this.clase = "warning";
          document.getElementById("message").click();
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.titulo = "Error";
        this.mensaje = "Algo salio mal";
        this.clase = "danger";
        document.getElementById("message").click();
      }
    );
  }

  guardar(id, ruta) {
    this.cargarDatosCatalogo = true;
    let json = this.data.value;
    if (ruta == 'quitar-beca') {
      json = {
        id: this.data.value.id
      };
    }
    this.crud.editar(id, json, ruta).subscribe(
      resultado => {
        this.titulo = ruta.toUpperCase();
        this.mensaje = resultado.messages;

        if (resultado.status == 201) {
          this.clase = 'success';
        } else {
          this.clase = 'warning';
        }

        document.getElementById("message").click();
        document.getElementById("cargar_datos_actualizar").click();

        this.cargarDatosCatalogo = false;
        this.cancelarModal(ruta);
      },
      error => {
        const e = JSON.parse(error._body)
        this.cargarDatosCatalogo = false;
        this.titulo = ruta.toUpperCase();
        this.mensaje = e ? e.messages : 'No especificado';
        this.clase = "error";
        document.getElementById("message").click();
      }
    );
  }
  guardarDatos(ruta, id_modal) {

    this.cargando = true;

    let datos_nuevos = this.datos_personalesF.value;
    // console.log(datos_nuevos);
    // console.log(ruta);

    this.crud.crear(datos_nuevos, ruta).subscribe(
      resultado => {
        this.titulo = 'Actualización de datos personales';
        this.mensaje = resultado.messages;
        this.cargando = false;
        if (resultado.status == 200) {
          this.clase = 'success';
        } else {
          this.clase = 'warning';
        }
        document.getElementById("message").click();
        this.cancelarModal(id_modal);
        this.cancelarModal('datos_personales');
        document.getElementById("cargar_datos_actualizar").click();
      }, (e) => {
        console.log(e);
        this.cargando = false;
        this.titulo = 'Error';
        this.mensaje = e.error.messages
        this.clase = "error";
        this.cancelarModal(id_modal);
        document.getElementById("message").click();
      })
  }
  guardarBaja(ruta, id) {

    this.borrarCargando = true;
    this.cargando = true;
    this.crud.crear(this.data.value, ruta).subscribe(
      resultado => {
        this.titulo = ruta.toUpperCase();
        this.mensaje = resultado.messages;

        if (resultado.status == 200) {
          this.clase = 'success';
        } else {
          this.clase = 'warning';
        }

        document.getElementById("message").click();
        this.alumnos.baja = 1;

        this.borrarCargando = false;
        this.cargando = false;
        this.cancelarModal(id);
        if (ruta != 'reincorporar')
          this.cancelarModal(ruta);
        document.getElementById("cargar_datos_actualizar").click();
      },
      error => {
        const e = JSON.parse(error._body)
        this.borrarCargando = false;
        this.cargando = false;
        this.titulo = ruta.toUpperCase();
        this.mensaje = e ? e.messages : 'No especificado';
        this.clase = "error";
        document.getElementById("message").click();
      }
    );
  }

  guardarPausa(pausa, invalidar, x, y) {
    // console.log(invalidar);
    // console.log(pausa);

    //this.borrarCargando = true;
    //this.cargando = true;
    let dato = this.data.value;


    dato["observaciones"] = pausa;
    dato["invalidar_periodo"] = invalidar;
    console.log(dato);
    this.crud.crear(dato, "pausa").subscribe(
      resultado => {

        this.mensaje = resultado.messages;

        if (resultado.status == 200) {
          this.clase = 'success';
        } else {
          this.clase = 'warning';
        }

        document.getElementById("message").click();

        this.cancelarModal('pausa');
        this.cancelarModal('confirmarEliminar5');
        this.cargando = false;
      },
      error => {
        const e = JSON.parse(error._body)
        this.borrarCargando = false;
        this.cargando = false;
        this.mensaje = e ? e.messages : 'No especificado';
        this.clase = "error";
        document.getElementById("message").click();
      }
    );
  }


  eliminar(id, ruta) { 
    this.borrarItem = id;
    this.borrarRuta = ruta;
    document.getElementById("confirmarEliminar2").classList.add("is-active");
  }

  borrar(item: any, ruta): void {
    this.cargando = true;
    this.borrarCargando = true;
    this.crud.eliminar(item, ruta).subscribe(
      data => {
        this.cargando = false;
        this.borrarCargando = false;

        this.titulo = ruta.toUpperCase();
        this.mensaje = "Se eliminó el elemento de la lista.";
        this.clase = "success";
        document.getElementById("message").click();

        document.getElementById("confirmarEliminar2").classList.remove("is-active");
        document.getElementById("cargar_datos_actualizar").click();
      },
      error => {
        const e = JSON.parse(error._body)
        this.cargarDatosCatalogo = false;
        this.titulo = ruta.toUpperCase();
        this.mensaje = e ? e.messages : 'No especificado';
        this.clase = "error";
        document.getElementById("message").click();
      }
    );
  }

  predeterminado(modelo) {
    this.data.controls.personas_rfcs['controls'].forEach(element => {
      element.controls.predeterminado.patchValue(0);
    });

    modelo.patchValue(1);
  }

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  imprimirKardex() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;

      let alumno = this.kardex[this.alumnos.id];
      let conteo_lienas = 4;

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
      //Nombre empresa
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 110, 12, { align: "center" });
      doc.text(this.configuracion.empresa.subnombre, 110, 17, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 110, 20, { align: "center" });

      conteo_lienas += 20;
      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");

      doc.text("HISTORIAL ACADEMICO", 110, conteo_lienas, { align: "center" });
      conteo_lienas += 4;

      doc.setFontSize(6);
      doc.text("CARRERA: ", 10, conteo_lienas, { align: "left" });
      doc.text("CLAVE: ", 145, conteo_lienas, { align: "left" });

      doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      doc.text("NOMBRE: ", 10, conteo_lienas + 4, { align: "left" });
      doc.text("TURNO: ", 145, conteo_lienas + 4, { align: "left" });

      doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
      doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

      doc.text("MATRICULA: ", 10, conteo_lienas + 8, { align: "left" });
      doc.text("GRUPO: ", 145, conteo_lienas + 8, { align: "left" });

      doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
      doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

      ///////////////////////////////////////
      doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre, 30, conteo_lienas, { align: "left" });
      doc.text(this.alumnos.carreras.sigla, 160, conteo_lienas, { align: "left" });

      doc.text(this.alumnos.alumnos_metadatos.nombre + " " + this.alumnos.alumnos_metadatos.apellido_paterno + " " + this.alumnos.alumnos_metadatos.apellido_materno, 30, conteo_lienas + 4, { align: "left" });
      doc.text(this.alumnos.grupos.turnos.nombre, 160, conteo_lienas + 4, { align: "left" });

      doc.text(this.alumnos.matricula ? this.alumnos.matricula : '', 30, conteo_lienas + 8, { align: "left" });
      doc.text(this.alumnos.grupos.clave + " " + this.alumnos.grupos.nivel + " " + this.alumnos.grupos.identificador, 160, conteo_lienas + 8, { align: "left" });

      conteo_lienas += 12;
      let conteo_lin = [];
      conteo_lin[0] = conteo_lienas;
      conteo_lin[1] = conteo_lienas;
      let columns1 = [];
      let rows1 = [];
      let columns2 = [];
      let rows2 = [];
      let columns3 = [];
      let rows3 = [];
      let materias = this.carreras_planes[this.alumnos.carrera_plan.id].materias;

      for (let key in materias) {
        let c = parseInt(key);
        if (c > 0) {
          let periodo = "";
          if (typeof this.periodos_escolares[this.alumnos.carrera_plan.id] != 'undefined') {
            if (typeof this.periodos_escolares[this.alumnos.carrera_plan.id][key] != 'undefined') {
              periodo = this.periodos_escolares[this.alumnos.carrera_plan.id][key].nombre;
            }
          }
          columns1 = [
            {
              title: this.carreras_planes[this.alumnos.carrera_plan.id].carreras.tipos_periodos.nombre_para_mostrar + ": " + key,
              dataKey: "nivel"
            },
            {
              title: "PERIODO: " + periodo,
              dataKey: "periodo"
            }
          ];

          columns2 = [
            { title: "", dataKey: "mate" },
            { title: "CALIF.", dataKey: "calif" },
            { title: "REGULARIZACIÓN ", dataKey: "regula" }
          ];
          let modalidades_id = this.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].modalidades.id;
          columns3 = [
            { title: "MATERIA", dataKey: "materia" }
          ];
          let opcion = this.carreras_planes[this.alumnos.carrera_plan.id].opciones_calificacion;
          for (let ko in opcion) {
            if (modalidades_id == opcion[ko].modalidades_id) {
              columns3.push({ title: opcion[ko].nombre, dataKey: opcion[ko].nombre })
            }
          }
          let tamano_nombre_materia = 0;
          let materias_rows = [];
          for (let km in materias[key]) {
            if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
              let materia_d = {};

              let materia_nombre = materias[key][km].nombre;
              if (materias[key][km].tiene_practica) {
                materia_nombre = materia_nombre + " *";
              }

              if (materia_nombre.length > 48) {
                tamano_nombre_materia++;
              }

              materia_d["materia"] = materia_nombre;
              for (let ko in opcion) {

                if (modalidades_id == opcion[ko].modalidades_id) {

                  let promedio = {
                    aprobado: '',
                    carreras_planes_id: '',
                    clave: '',
                    id: '',
                    identificador: '',
                    materia_clave: '',
                    materia_id: '',
                    materia_nombre: '',
                    nivel: '',
                    opciones_calificacion_id: '',
                    periodos_escolares_id: '',
                    personas_id: '',
                    promedio: '',
                    turno: '',
                    valor_minimo_aprobatorio: '',
                  };
                  let no_opcion = false;

                  if (alumno.niveles[key]) {
                    if (alumno.niveles[key][materias[key][km].id]) {
                      if (alumno.niveles[key][materias[key][km].id][opcion[ko].id]) {
                        promedio.promedio = alumno.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
                      } else {
                        no_opcion = true;
                      }
                    } else {
                      no_opcion = true;
                    }
                  } else {
                    no_opcion = true;
                  }
                  if (no_opcion) {
                    promedio.promedio = '';
                  }
                  if (parseFloat(promedio.promedio) < parseFloat(promedio.valor_minimo_aprobatorio)) {
                    promedio.promedio = this.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].modalidades.materia_leyenda_para_imprimir;
                  }

                  materia_d[opcion[ko].nombre] = promedio.promedio;
                }
              }

              materias_rows.push(materia_d);
            }
          }
          rows3 = materias_rows;

          if (c % 2 == 0) {
            if (conteo_lin[1] + (rows3.length + tamano_nombre_materia) * 4.9 > 356) {
              conteo_lin[0] = 10;
              conteo_lin[1] = 10;
              conteo_lienas = 10;
              doc.addPage();
            }
            (doc as any).autoTable(columns1, rows1, {
              createdHeaderCell: function (cell, data) {
                cell.styles.halign = "left";
              },
              tableWidth: 96,
              margin: { left: 110, right: 10 },
              startY: conteo_lin[1],
              styles: {
                fontSize: 7,
                font: "helvetica",
                halign: "left",
                fillColor: "#FFFFFF",
                textColor: "#000000",
                lineColor: "#000000",
                lineWidth: 0.1,
                overflow: 'linebreak',
                cellPadding: 0.3
              },
              headStyles: {
                lineColor: "#000000",
                lineWidth: 0.1,
                fillColor: "#fbfbfb"
              },
              theme: "grid",
              columnStyles: {
                nivel: { cellWidth: 30 },
                periodo: { cellWidth: 66 }
              }
            });
            conteo_lin[1] += 3.5;
            const esto = this;
            let columnStyles = {
              materia: {
                halign: "left",
                cellWidth: 42
              }
            };

            for (let ko in opcion) {
              columnStyles[opcion[ko].nombre] = { cellWidth: (150 / (opcion.length)) };
            }

            (doc as any).autoTable(columns3, rows3, {
              didParseCell: function (cell) {
                let value = cell;
                cell = cell.cell;
                cell.styles.fillColor = "#ffffff";
                cell.styles.fontColor = "#000000";
                if ((value.cell.text * 1) < esto.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                  cell.styles.textColor = "#e11d1d";
                };

                if (value.column.dataKey != 'materia') {
                  cell.styles.halign = 'center';
                };
              },
              tableWidth: 96,
              margin: { left: 110, right: 10 },
              startY: conteo_lin[1],
              styles: {
                fontSize: 7,
                font: "helvetica",
                halign: "left",
                fillColor: "#FFFFFF",
                textColor: "#000000",
                lineColor: "#000000",
                lineWidth: 0.1,
                overflow: 'linebreak',
                cellPadding: 0.3
              },
              theme: "grid",
              columnStyles: {
                materia: {
                  halign: "left",
                  cellWidth: 70
                }
              },
              headStyles: {
                cellPadding: 2,
                lineWidth: 0.1,
                valign: "top",
                fontSize: 6,
                fontStyle: "bold",
                fillColor: "#fbfbfb",
                textColor: "#000000",
                lineColor: "#000000"
              }
            });
            conteo_lin[1] += (rows3.length + tamano_nombre_materia) * 4.9;
          } else {
            if (conteo_lin[0] + (rows3.length + tamano_nombre_materia) * 4.9 > 240) {
              conteo_lin[0] = 10;
              conteo_lin[1] = 10;
              conteo_lienas = 10;
              doc.addPage();
            }
            (doc as any).autoTable(columns1, rows1, {
              createdHeaderCell: function (cell, data) {
                cell.styles.halign = "left";
              },
              tableWidth: 96,
              startY: conteo_lin[0],
              styles: {
                fontSize: 7,
                font: "helvetica",
                halign: "left",
                fillColor: "#FFFFFF",
                textColor: "#000000",
                lineColor: "#000000",
                lineWidth: 0.1,
                overflow: 'linebreak',
                cellPadding: 0.3
              },
              theme: "grid",
              margin: { left: 10 },
              headStyles: {
                lineColor: "#000000",
                lineWidth: 0.1,
                fillColor: "#fbfbfb"
              },
              columnStyles: {
                nivel: { cellWidth: 30 },
                periodo: { cellWidth: 66 }
              }
            });
            conteo_lin[0] += 3.5;
            const esto = this;
            (doc as any).autoTable(columns3, rows3, {
              didParseCell: function (cell) {
                let value = cell;
                cell = cell.cell;
                cell.styles.fillColor = "#ffffff";
                cell.styles.fontColor = "#000000";
                if ((value.cell.text * 1) < esto.carrera_modulo_nivel[this.alumnos.carrera_plan.id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                  cell.styles.textColor = "#e11d1d";
                };

                if (value.column.dataKey != 'materia') {
                  cell.styles.halign = 'center';
                };
              },
              tableWidth: 96,
              startY: conteo_lin[0],
              styles: {
                fontSize: 7,
                font: "helvetica",
                halign: "left",
                fillColor: "#FFFFFF",
                textColor: "#000000",
                lineColor: "#000000",
                lineWidth: 0.1,
                overflow: 'linebreak',
                cellPadding: 0.3
              },
              theme: "grid",
              margin: { left: 10 },
              columnStyles: {
                materia: {
                  halign: "left",
                  cellWidth: 70
                }
              },
              headStyles: {
                cellPadding: 2,
                lineWidth: 0.1,
                fontSize: 6,
                valign: "top",
                fontStyle: "bold",
                fillColor: "#fbfbfb",
                textColor: "#000000",
                lineColor: "#000000"
              }
            });

            conteo_lin[0] += (rows3.length + tamano_nombre_materia) * 4.9;
          }
        }
      }
      conteo_lienas = conteo_lin[1] + 2;
      if (conteo_lin[0] > conteo_lin[1])
        conteo_lienas = conteo_lin[0] + 2;

      conteo_lienas += 2;
      doc.text("ACREDITADO " + alumno.total_creditos_aprobados + " DE UN TOTAL DE " + alumno.total_creditos + " CRÉDITOS. CON UN PROMEDIO DE: " + alumno.promedio, 10, conteo_lienas, { align: "left" });

      doc.setFontSize(7);
      doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "kardex.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  imprimirFinanza() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;

      let alumno = this.kardex[this.alumnos.id];
      let conteo_lienas = 4;

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
      //Nombre empresa
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 110, 12, { align: "center" });
      doc.text(this.configuracion.empresa.subnombre, 110, 17, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 110, 20, { align: "center" });

      conteo_lienas += 20;
      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");

      doc.text("HISTORIAL FINANCIERO", 110, conteo_lienas, { align: "center" });
      conteo_lienas += 4;

      doc.setFontSize(6);
      doc.text("CARRERA: ", 10, conteo_lienas, { align: "left" });
      doc.text("CLAVE: ", 145, conteo_lienas, { align: "left" });

      doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      doc.text("NOMBRE: ", 10, conteo_lienas + 4, { align: "left" });
      doc.text("TURNO: ", 145, conteo_lienas + 4, { align: "left" });

      doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
      doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

      doc.text("MATRICULA: ", 10, conteo_lienas + 8, { align: "left" });
      doc.text("GRUPO: ", 145, conteo_lienas + 8, { align: "left" });

      doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
      doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

      ///////////////////////////////////////
      doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre, 30, conteo_lienas, { align: "left" });
      doc.text(this.alumnos.carreras.sigla, 160, conteo_lienas, { align: "left" });

      doc.text(this.alumnos.alumnos_metadatos.nombre + " " + this.alumnos.alumnos_metadatos.apellido_paterno + " " + this.alumnos.alumnos_metadatos.apellido_materno, 30, conteo_lienas + 4, { align: "left" });
      doc.text(this.alumnos.grupos.turnos.nombre, 160, conteo_lienas + 4, { align: "left" });

      doc.text(this.alumnos.matricula ? this.alumnos.matricula : '', 30, conteo_lienas + 8, { align: "left" });
      doc.text(this.alumnos.grupos.clave + " " + this.alumnos.grupos.nivel + " " + this.alumnos.grupos.identificador, 160, conteo_lienas + 8, { align: "left" });

      conteo_lienas += 15;

      doc.text("INSCRIPCION Y COLEGIATURA", 110, conteo_lienas, { align: "center" });
      conteo_lienas += 3;

      let columns1 = [], columns2 = [], columns3 = [];

      let rows1 = [], rows2 = [], rows3 = [];

      columns1 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' },
        { title: 'PAGO EL', dataKey: 'created_at' },
        { title: 'PRECIO', dataKey: 'precio' },
        { title: 'DESCUENTO', dataKey: 'descuento' },
        { title: 'RECARGO', dataKey: 'recargo' },
        { title: 'TOTAL', dataKey: 'total' },
      ];

      columns2 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' },
        { title: 'CANTIDAD', dataKey: 'cantidad' },
        { title: 'PRECIO', dataKey: 'precio' },
        { title: 'DESCUENTO', dataKey: 'descuento' },
        { title: 'TOTAL', dataKey: 'total' },
      ];

      columns3 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'VIGENCIA INICIO', dataKey: 'inicio' },
        { title: 'VIGENCIA FIN', dataKey: 'fin' },
        { title: 'TOTAL', dataKey: 'total' },
      ];
      this.finanza.data.forEach(inscripcion => {
        rows1[0] = [];
        rows1[0]["id"] = inscripcion.nivel;
        rows1[0]["descripcion"] = inscripcion.tipo;
        rows1[0]["fecha"] = inscripcion.fecha_pago;
        rows1[0]["created_at"] = inscripcion.created_at;
        rows1[0]["precio"] = this.convertirMoneda(parseFloat(inscripcion.precio_real));
        rows1[0]["descuento"] = this.convertirMoneda(parseFloat(inscripcion.descuento));
        rows1[0]["recargo"] = this.convertirMoneda(parseFloat(inscripcion.recargo_inscripcion));
        rows1[0]["total"] = inscripcion.total_abonado != 'DEBE' ? this.convertirMoneda(parseFloat(inscripcion.total_abonado)) : inscripcion.total_abonado;

        rows2 = [];

        (doc as any).autoTable(columns1, rows1, {
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          bodyStyles: {
            cellPadding: 0.4
          },
          theme: "grid",
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });

        inscripcion.colegiaturas.forEach(colegiatura => {
          let raw = [];
          raw["id"] = colegiatura.numero_mensualidad;
          raw["descripcion"] = "COLEGIATURA";
          raw["fecha"] = colegiatura.fecha_pago;
          raw["created_at"] = colegiatura.created_at;
          raw["precio"] = this.convertirMoneda(parseFloat(colegiatura.precio_real));
          raw["descuento"] = this.convertirMoneda(parseFloat(colegiatura.descuento));
          raw["recargo"] = this.convertirMoneda(parseFloat(colegiatura.recargo_colegiatura));
          raw["total"] = this.convertirMoneda(parseFloat(colegiatura.total_abonado));

          rows2.push(raw);
        });
        conteo_lienas += 10;
        (doc as any).autoTable(columns1, rows2, {
          didParseCell: function (cell) {
            let data = cell;
            cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3,
            cellPadding: 0.4
          },
          headStyles: {
            lineColor: "#000000",
            fillColor: "#e2e2e2",
            lineWidth: 0.3
          },
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });

        conteo_lienas += inscripcion.colegiaturas.length * 5;
      });
      if (this.finanza.otros_pagos.length > 0) {
        conteo_lienas += 10;
        doc.text("OTROS PAGOS", 110, conteo_lienas, { align: "center" });
        conteo_lienas += 3;

        this.finanza.otros_pagos.forEach(otro => {

          otro.movimientos_articulos.forEach((mov, index) => {
            let raw = [];
            raw["id"] = index + 1;
            raw["descripcion"] = mov.articulos.nombre;
            raw["fecha"] = mov.created_at;
            raw["cantidad"] = mov.cantidad;
            raw["precio"] = this.convertirMoneda(parseFloat(mov.precio_unitario));
            raw["descuento"] = this.convertirMoneda(parseFloat(mov.descuento));
            raw["total"] = this.convertirMoneda(parseFloat(mov.importe));

            rows3.push(raw);
          });

          (doc as any).autoTable(columns2, rows3, {
            didParseCell: function (cell) {
              let data = cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 7, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.3,
              cellPadding: 0.4
            },
            headStyles: {
              lineColor: "#000000",
              fillColor: "#e2e2e2",
              lineWidth: 0.3
            },
            tableWidth: 'auto',
            margin: { right: 10, left: 10 },
          });
          conteo_lienas += otro.movimientos_articulos.length * 5;
        });
      }

      if (this.finanza.cupones.length > 0) {
        conteo_lienas += 10;
        doc.text("CUPON", 110, conteo_lienas, { align: "center" });
        conteo_lienas += 3;
        rows3 = [];
        this.finanza.cupones.forEach((mov, index) => {
          let raw = [];
          raw["id"] = index + 1;
          raw["descripcion"] = mov.articulos.nombre;
          raw["inicio"] = mov.inicio_vigencia;
          raw["fin"] = mov.fin_vigencia;
          raw["total"] = this.convertirMoneda(parseFloat(mov.importe));

          rows3.push(raw);
        });

        (doc as any).autoTable(columns3, rows3, {
          didParseCell: function (cell) {
            let data = cell;
            cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: conteo_lienas,
          styles: {
            fontSize: 7, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3,
            cellPadding: 0.4
          },
          headStyles: {
            lineColor: "#000000",
            fillColor: "#e2e2e2",
            lineWidth: 0.3
          },
          tableWidth: 'auto',
          margin: { right: 10, left: 10 },
        });
      }

      doc.setFontSize(7);
      doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "finanza.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  imprimirIncidencia() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;

      let alumno = this.kardex[this.alumnos.id];
      let conteo_lienas = 4;

      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
      //Nombre empresa
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 110, 12, { align: "center" });
      doc.text(this.configuracion.empresa.subnombre, 110, 17, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 110, 20, { align: "center" });

      conteo_lienas += 20;
      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");

      doc.text("HISTORIAL DE INCIDENCIAS", 110, conteo_lienas, { align: "center" });
      conteo_lienas += 4;

      doc.setFontSize(6);
      doc.text("CARRERA: ", 10, conteo_lienas, { align: "left" });
      doc.text("CLAVE: ", 145, conteo_lienas, { align: "left" });

      doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
      doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

      doc.text("NOMBRE: ", 10, conteo_lienas + 4, { align: "left" });
      doc.text("TURNO: ", 145, conteo_lienas + 4, { align: "left" });

      doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
      doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

      doc.text("MATRICULA: ", 10, conteo_lienas + 8, { align: "left" });
      doc.text("GRUPO: ", 145, conteo_lienas + 8, { align: "left" });

      doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
      doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

      ///////////////////////////////////////
      doc.setFont("helvetica", "", "normal");

      doc.text(this.alumnos.carreras.nombre + " - " + this.alumnos.carrera_plan.nombre, 30, conteo_lienas, { align: "left" });
      doc.text(this.alumnos.carreras.sigla, 160, conteo_lienas, { align: "left" });

      doc.text(this.alumnos.alumnos_metadatos.nombre + " " + this.alumnos.alumnos_metadatos.apellido_paterno + " " + this.alumnos.alumnos_metadatos.apellido_materno, 30, conteo_lienas + 4, { align: "left" });
      doc.text(this.alumnos.grupos.turnos.nombre, 160, conteo_lienas + 4, { align: "left" });

      doc.text(this.alumnos.matricula ? this.alumnos.matricula : '', 30, conteo_lienas + 8, { align: "left" });
      doc.text(this.alumnos.grupos.clave + " " + this.alumnos.grupos.nivel + " " + this.alumnos.grupos.identificador, 160, conteo_lienas + 8, { align: "left" });

      conteo_lienas += 15;

      let columns1 = [];

      let rows1 = [];

      columns1 = [
        { title: 'N°', dataKey: 'id' },
        { title: 'DESCRIPCION', dataKey: 'descripcion' },
        { title: 'FECHA', dataKey: 'fecha' }
      ];

      this.lista_incidencias.forEach((incidencia, index) => {
        let row = [];
        row["id"] = index + 1;
        row["descripcion"] = incidencia.descripcion;
        row["fecha"] = incidencia.created_at;

        rows1.push(row);
      });

      (doc as any).autoTable(columns1, rows1, {
        startY: conteo_lienas,
        styles: {
          fontSize: 7, font: "helvetica",
          halign: "center",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          cellPadding: 0.4
        },
        theme: "grid",
        tableWidth: 'auto',
        margin: { right: 10, left: 10 },
      });

      doc.setFontSize(7);
      doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });

      this.cargando = false;

      // doc.autoPrint();
      const string = (doc as any).output("datauristring", "incidencias.pdf");

      $("#contenido").html(
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>");

    }, 10);
  }

  cancelarModal(id) {
    document.getElementById(id).classList.remove('is-active');
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }


  }

  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }

  abrirImagen(imagen) {
    $("#contenido").html(
      "<img border='0' style='border:0px' width='100%' height='100%' src='" +
      imagen +
      "'>");
  }
}
